const prefix = "/";

export default [
  {
    path: `${prefix}usuarios`,
    meta: { auth: true, public: false },
    title: "usuários",
    name: "UserIndex",
    component: () => import(`../views/user/UserIndex.vue`),
  },
  {
    path: `${prefix}/usuarios/importar`,
    meta: { auth: true, public: false },
    title: "Importar Usuários",
    name: "UserImport",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/user/UserImport.vue`
      ),
  },
];
